
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 5c3.854 0 7 3.146 7 7a7.027 7.027 0 01-3.094 5.813C22.473 19.343 25 22.882 25 27.001h-2c0-4.431-3.569-8-8-8s-8 3.569-8 8H5c0-4.119 2.527-7.658 6.094-9.188A7.025 7.025 0 018 12c0-3.854 3.146-7 7-7zm0 2c-2.773 0-5 2.227-5 5s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5z"}})])
          )
        }
      }
    